export default __webpack_public_path__ + "static/button-spacing-after.light-2a825864a6416c59280955860eef249a.png";